import './App.css';
import ImprovedEnterpriseLayoutPreview from './Layout/main_layout';
import LoginInterface from './login-interface';
import { Route, Routes } from 'react-router-dom';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { GlobalErrorHandler } from './components/common/GlobalErrorHandler';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <GlobalErrorHandler>
        <ErrorBoundary
          showNotification={true}
          logError={true}
          errorMessage="The application encountered an error. Please try again."
        >
          <Routes>
            <Route path="/" element={<LoginInterface />} />
            <Route
              path="/Layout/main_layout"
              element={
                <ProtectedRoute>
                  <ImprovedEnterpriseLayoutPreview />
                </ProtectedRoute>
              }
            />
            {/* other routes */}
          </Routes>
        </ErrorBoundary>
      </GlobalErrorHandler>
    </AuthProvider>
  );
}

export default App;
